import Vue from 'vue/dist/vue.js'
import axios from 'axios'
import $ from 'jquery'
import {
  CATEGORY_LIST_API,
  PRODUCT_LIST_API,
  SUBCATEGORY_LIST_API,
  updateMetaTitle,
} from './consts'

export default function() {
  new Vue({
    el: '.js-product-list',
    name: 'Product List',
    data() {
      return {
        products: [],
        isLoadingProducts: true,
        currentPageIndex: 0,
        totalPages: 0,
        productPerPage: 0,
        paginationUrl: '',
        loggedInUser: null,
        categoryFilter: [],
        currentCategory: [],
        finishFilter: [],
        isFinishFilterOpen: false,
        brandFilter: [],
        isBrandFilterOpen: false,
        isPriceFilterOpen: false,
        isSearch: false,
      };
    },
    async mounted() {

      let productListApiEndpoint = PRODUCT_LIST_API + this.$el.dataset.category + '/' + this.$el.dataset.subcategory;

      const originalParams = new URLSearchParams(window.location.search);
      const newParams = new URLSearchParams();

      // build breadcrumb
      let crumbs = [{name: 'Home', link: '/'}, {name: 'Products', link: '/products'}];

      if (originalParams.get('type')) {
        newParams.set('type', originalParams.get('type'));
      }
      if (originalParams.get('brand')) {
        newParams.set('brand', originalParams.get('brand'));
      }
      if (originalParams.get('sort')) {
        newParams.set('sort', originalParams.get('sort'));
      }
      if (originalParams.get('limit')) {
        newParams.set('limit', originalParams.get('limit'));
        this.productPerPage = originalParams.get('limit');
      } else {
        newParams.set('limit', '9');
        this.productPerPage = '9';
      }
      if (originalParams.get('page')) {
        newParams.set('page', originalParams.get('page'));
      } else {
        newParams.set('page', '1');
      }
      if (originalParams.get('finish')) {
        newParams.set('finish', originalParams.get('finish'));
      }
      if (window.location.pathname === '/products/search') {
        this.isSearch = true;
        if (originalParams.get('q')) {
          newParams.set('q', originalParams.get('q'));
        }
        if (originalParams.get('brand')) {
          newParams.set('brand', originalParams.get('brand'));
        }
        document.querySelector('[data-category-name]').textContent = 'Search';
        productListApiEndpoint = SUBCATEGORY_LIST_API + 'search';
        crumbs.push({
          name: 'Search',
          link: '#'
        })
      }
      if (newParams.entries()) {
        productListApiEndpoint = productListApiEndpoint + '?' + newParams.toString();
      }
      
      const response = await axios.get(productListApiEndpoint)
      if (this.isSearch) {

        this.products = response.data.data;
        document.querySelector('[data-category-name]').textContent = 'Search';

        console.log(response.data);

        // here to build pagination elements for seach - note diference in data

        this.currentPageIndex = parseInt(newParams.get('page'));
        newParams.delete('page');
        this.paginationUrl = window.location.pathname + '?' + newParams.toString(); // append page while rendering pagination buttons

        if (response.data.product_total_count < parseInt(this.productPerPage) || parseInt(this.productPerPage) === 0) {
          this.totalPages = 0;
        } else {
          this.totalPages = Math.ceil((response.data.product_total_count ?? 0) / parseInt(this.productPerPage));
        }


      } else {

        this.products = response.data.data.products;

        console.log(response.data);

        updateMetaTitle(response.data.data.name);

        // here to build pagination elements
        this.currentPageIndex = parseInt(newParams.get('page'));
        newParams.delete('page');
        this.paginationUrl = window.location.pathname + '?' + newParams.toString(); // append page while rendering pagination buttons

        if (response.data.data.product_total_count < parseInt(this.productPerPage) || parseInt(this.productPerPage) === 0) {
          this.totalPages = 0;
        } else {
          this.totalPages = Math.ceil((response.data.data.product_total_count ?? 0) / parseInt(this.productPerPage));
        }

        if (response.data.data.finishes) {
          this.finishFilter = Object.values(response.data.data.finishes);
        }

        if (response.data.data.brands) {
          this.brandFilter = Object.values(response.data.data.brands);
        }

        let currentType = null;
        const subcategoryResponse = await axios.get(SUBCATEGORY_LIST_API + this.$el.dataset.category + '/' + this.$el.dataset.subcategory)
        const subcategoryRaw = subcategoryResponse.data.data;
        subcategoryRaw.types.forEach(typeItem => {
          if (window.location.search.includes(typeItem.slug)) {
            typeItem.active = true;
            currentType = typeItem;
          } else {
            typeItem.active = false;
          }
        })

        this.currentCategory = subcategoryRaw;

        if (subcategoryRaw && subcategoryRaw.parent_slug && subcategoryRaw.parent_name) {
          crumbs.push({name: subcategoryRaw.parent_name, link: `/products/${subcategoryRaw.parent_slug}`})
        }

        if (subcategoryRaw && subcategoryRaw.slug && subcategoryRaw.name) {
          if (subcategoryRaw.parent_slug) {
            crumbs.push({name: subcategoryRaw.name, link: `/products/${subcategoryRaw.parent_slug}/${subcategoryRaw.slug}?limit=9&page=1`});

            if (currentType) {
              crumbs.push({name: currentType.name, link: `/products/${subcategoryRaw.parent_slug}/${subcategoryRaw.slug}?type=${currentType.slug}&limit=9&page=1`});
            }
          } else {
            crumbs.push({name: subcategoryRaw.name, link: `/products/${subcategoryRaw.slug}?limit=9&page=1`})
          }
        }

        document.querySelector('[data-category-name]').textContent = this.currentCategory.name;
      }

      document.querySelector('[data-breadcrumbs]').innerHTML = crumbs.map(item => {
        return `<a href="${item.link}" class="small-button">${item.name}</a>`;
      }).join('<span>/</span>');

      this.isLoadingProducts = false;

      const categoryResponse = await axios.get(CATEGORY_LIST_API)
      const categoryFilterRaw = categoryResponse.data.data;
      categoryFilterRaw.forEach(categoryItem => {
        categoryItem.active = window.location.pathname.includes(categoryItem.slug);
        categoryItem.categories.forEach(childCategoryItem => {
          childCategoryItem.active = window.location.pathname.includes(childCategoryItem.slug);
        })
      })
      this.categoryFilter = categoryFilterRaw;

      await axios.get('/api/user').
        then(response => (this.loggedInUser = response.data.data)).
        catch(error => {
          // console.log(error)
          this.loggedInUser = false;
        });
       
    },
    computed: {

      fiveMaximumPages() {
        let pages = [];
        let start = 1;
        let end = this.totalPages;
        let i = 1;

        if (this.totalPages > 5 && this.currentPageIndex < 5) {
          end = 5
        }
        else if (this.totalPages > 5 && this.currentPageIndex > 3) {
          start = this.currentPageIndex - 2
          end = (parseInt(this.currentPageIndex) + 2) > this.totalPages ? this.totalPages : parseInt(this.currentPageIndex) + 2;
          i = start
        }

        while (i <= end) {
          pages.push(i);
          i++;
        }

        return pages;
      },
    },
    methods: {
      showAddToProject(e) {
        document.getElementById('productid').value = e.target.dataset.productId;
        document.getElementById('productbrand').value = e.target.dataset.productBrand;
        document.getElementById('producturl').value = e.target.dataset.productUrl;
        document.getElementById('productname').value = e.target.dataset.productName;
        document.getElementById('productimageurl').value = e.target.dataset.productImageUrl;

        if (this.loggedInUser !== null) {
          if (this.loggedInUser === false) {
            $('.my-project-popup-wrapper').show();
          } else {
            $('.add-product-popup-wrapper').show();
          }
        }

      },
      linkGenerator(categoryItem) {
        let parts = ['/products'];
        if (categoryItem.parent_slug) {
          parts.push(categoryItem.parent_slug);
        }
        if (categoryItem.slug) {
          parts.push(categoryItem.slug);
        }
        return parts.join('/');
      },
      filterLinkGenerator(type, slug) {
        const params = new URLSearchParams(window.location.search);
        params.set(type, slug);
        if(params.has('limit')) {
          params.set('limit', params.get('limit'));
        } else {
          params.set('limit', '9');
        }
        params.set('page', '1');
        return window.location.pathname + '?' + params.toString();
      },
      isCurrentPage(pageNumber) {
        return parseInt(this.currentPageIndex) === parseInt(pageNumber);
      }
    },
  });
}
